<script>
import {webhook as columns} from '../../tables'

export default {
  props: {
    path: {
      type: String,
      required: true
    }
  },
  computed: {
    pagination() {
      return {
        current: this.items.current_page,
        total: this.items.total,
        pageSize: this.pageSize,
        showSizeChanger: true
      }
    },
    pageSize() {
      return parseInt(this.items.per_page)
    },
    drawerVisible() {
      return this.editing !== null || this.creating
    }
  },
  data: () => ({
    items: {},
    columns,
    loading: false,
    filters: {
      q: ''
    },
    editing: null,
    creating: false,
    stateChanging: [],
    deleting: []
  }),
  created() {
    this.items = this.getDefaultPagination()
    this.getItems()
  },
  methods: {
    getItems() {
      this.loading = true
      this.$http.get(this.path, {
        params: this.filters
      })
        .then((r) => this.items = r.data)
        .catch((e) => this.handleXhrError(e))
        .finally(() => this.loading = false)
    },
    tableChanged(pagination) {
      this.filters.page = pagination.current
      this.filters.per_page = pagination.pageSize
      this.pushState(this.filters)
      this.getItems()
    },
    toggleState(record) {
      this.stateChanging.push(record.hash)
      this.$http.patch(this.routeUri('hyperion.setting.webhook.patch',  { webhook_hash: record.hash}), {
        action: 'TOGGLE_STATE'
      })
        .then(() => this.onSuccessChangingState(record))
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.onFinishedChangingState(record))
    },
    onSuccessChangingState(record) {
      let index = this.items.data.findIndex(i => i.hash === record.hash)
      if (index > -1) {
        this.items.data[index].is_active = ! record.is_active
      }
    },
    onFinishedChangingState(record) {
      let index = this.stateChanging.indexOf(record.hash)
      if (index > -1) {
        this.stateChanging.splice(index, 1)
      }
    },
    closeDrawer() {
      this.creating = false
      this.editing = null
    },
    create() {
      this.creating = true
    },
    edit(record) {
      this.editing = record
    },
    onDeleteSuccess() {
      this.$notification.success({
        message: 'Success',
        description: 'Data has been successfully deleted!',
        onClose: () => window.location.reload()
      })
    },
    destroy(record) {
      this.deleting.push(record.hash)
      this.$http.delete(this.routeUri('hyperion.setting.webhook.destroy', { webhook_hash: record.hash}))
        .then((r) => this.onDeleteSuccess())
        .catch((e) => this.handleXhrError(e));
    }
  }
}
</script>
<template>
  <div>
    <div class="text-right" style="margin-bottom: 24px;">
      <a-button icon="plus" type="primary" @click="() => create()">New Webhook</a-button>
    </div>
    <a-card type="inner" size="small">
      <a-skeleton :loading="loading">
        <a-table :columns="columns"
                 :dataSource="items.data"
                 :pagination="pagination"
                 rowKey="hash"
                 @change="tableChanged">
          <h5 slot="datetime" slot-scope="datetime" class="text-center">
            {{ moment(datetime).format('DD/MM/YYYY HH:mm:ss') }}
          </h5>

          <h4 slot="webhook" slot-scope="record">
            <a-icon type="link" /> <code>{{ record.webhook_url }}</code>
          </h4>

          <h4 slot="token" slot-scope="record">
            <code>{{ record.secret_token }}</code>
          </h4>

          <div class="text-center" slot="hooks" slot-scope="record">
            <a-tag color="#87d068">{{ record.hooks.length }}</a-tag>
          </div>

          <div class="text-center" slot="state" slot-scope="record">
            <template v-if="stateChanging.includes(record.hash)">
              <a-tag style="margin-right: 0;">LOADING</a-tag>
            </template>
            <template v-else>
              <a-popconfirm title="Sure to disable webhook?" @confirm="() => toggleState(record)" v-if="record.is_active">
                <a-tag style="cursor:pointer; margin-right: 0;" color="#87d068">Active</a-tag>
              </a-popconfirm>
              <a-popconfirm title="Sure to enable webhook?" @confirm="() => toggleState(record)" v-else>
                <a-tag style="cursor:pointer; margin-right: 0" color="#f50">Inactive</a-tag>
              </a-popconfirm>
            </template>
          </div>

          <div class="text-right" slot="action" slot-scope="record">
            <a-button size="small" type="primary" icon="edit" @click="() => edit(record)"  />

            <a-popconfirm
              title="This will delete webhook, are you sure?"
              @confirm="() => destroy(record)">
              <a-button :loading="deleting.includes(record.hash)" type="danger" size="small" icon="delete" />
            </a-popconfirm>
          </div>

          <div slot="expandedRowRender" slot-scope="record">
            <ul>
              <li v-for="(hook, index) in record.hooks" :key="`hook-${index}`">
                <strong><code>{{ hook }}</code></strong>
              </li>
            </ul>
          </div>
        </a-table>
      </a-skeleton>
    </a-card>

    <a-drawer :width="720" placement="right" :closable="true" :visible="drawerVisible" @close="closeDrawer">
      <br>
      <template v-if="editing !== null || creating">
        <h-webhook-form :webhook="editing !== null ? editing : null" />
      </template>
    </a-drawer>
  </div>
</template>
